export function redirectTo(url: string) {
  if (window === window.parent) {
    window.location.href = url
  } else {
    window.parent.postMessage({ type: 'redirect', url: url }, '*')
  }
}
